import {Component, Input} from '@angular/core';

@Component({
  selector: 'answers-list',
  templateUrl: './answers-list.html',
})
export class AnswersListCmp {
  @Input() answers;
}
